import { useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import { SavListPage as SharedSavListPage } from '@/features/savs/components/SavListPage';
import { useSocietyChildren } from '../../societies/hooks/useSocieties';
import { useAuthStore } from '../../../stores/auth-store';

interface StatusCounts {
  enCours: number;
  termines: number;
  sansSuite: number;
}

export function SavListPage() {
  const navigate = useNavigate();
  const { currentUser, isAuthenticated } = useAuthStore();
  const { data: childrenData } = useSocietyChildren(currentUser?.societyId || '', { enabled: isAuthenticated });
  const hasChildren = useMemo(() => (childrenData || []).length > 0, [childrenData]);
  const [total, setTotal] = useState<number | undefined>();
  const [statusCounts, setStatusCounts] = useState<StatusCounts>({ enCours: 0, termines: 0, sansSuite: 0 });

  const pluralize = (count: number) => count > 1 ? 'éléments' : 'élément';

  return (
    <div>
      {/* Header */}
      <div className="tw-pt-4">
        <div className="tw-flex tw-items-center tw-gap-3">
          <AlertTriangle className="tw-w-8 tw-h-8 tw-text-affinicar-primary" />
          <h1 className="tw-text-2xl tw-font-bold tw-text-gray-900 tw-mb-0">
            SAV
            {total !== undefined && (
              <span className="tw-ml-1 tw-text-base tw-font-normal tw-text-gray-400">
                ({total} {pluralize(total)})
              </span>
            )}
          </h1>
        </div>
        <div className="tw-flex tw-items-center tw-gap-3 tw-mt-4">
          <span className="tw-px-2.5 tw-py-1 tw-text-xs tw-font-medium tw-rounded-full tw-bg-blue-100 tw-text-blue-700">
            {statusCounts.enCours} en cours
          </span>
          <span className="tw-px-2.5 tw-py-1 tw-text-xs tw-font-medium tw-rounded-full tw-bg-green-100 tw-text-green-700">
            {statusCounts.termines} terminé{statusCounts.termines > 1 ? 's' : ''}
          </span>
          <span className="tw-px-2.5 tw-py-1 tw-text-xs tw-font-medium tw-rounded-full tw-bg-red-100 tw-text-red-700">
            {statusCounts.sansSuite} sans suite
          </span>
        </div>
      </div>

      <SharedSavListPage
        onRowClick={(sav) => navigate(`/sav/${sav.id}`)}
        hideTitle
        embedded
        onTotalChange={setTotal}
        onStatusCountsChange={setStatusCounts}
        hideCompanyColumn={!hasChildren}
      />
    </div>
  );
}
